import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostGenerateSSETokenBodySchema } from "./postGenerateSSEToken.schema";

export const postGenerateSSEToken = (axios: IAxiosInstance) => {
  return async (body: TPostGenerateSSETokenBodySchema) => {
    const response = await axios.noRetry.post<ZealApiResponse<string>>(
      "/api/generateSSEToken",
      body
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
